import { useState } from "react";
import { Plus, Search, FolderOpen, Edit, Trash2 } from "lucide-react";

function Categories() {
  const [categories, setCategories] = useState([
    {
      id: 1,
      name: "Hydroponic Systems",
      products: 15,
    },
    {
      id: 2,
      name: "Nutrients",
      products: 25,
    },
    {
      id: 3,
      name: "Grow Lights",
      products: 10,
    },
    {
      id: 4,
      name: "Seeds",
      products: 40,
    },
    {
      id: 5,
      name: "Growing Media",
      products: 18,
    },
  ]);

  const [search, setSearch] = useState("");

  const filteredCategories = categories.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  const deleteCategory = (id) => {
    if (window.confirm("Delete Category?")) {
      setCategories(categories.filter((item) => item.id !== id));
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow p-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
        <div>
          <h2 className="text-3xl font-bold">
            Categories
          </h2>
          <p className="text-gray-500">
            Total Categories: {categories.length}
          </p>
        </div>

        <button className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-3 rounded-lg flex items-center gap-2">
          <Plus size={18} />
          Add Category
        </button>
      </div>

      {/* Search */}
      <div className="relative mb-6">
        <Search
          size={18}
          className="absolute left-4 top-4 text-gray-400"
        />

        <input
          type="text"
          placeholder="Search category..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full border rounded-xl pl-11 pr-4 py-3"
        />
      </div>

      {/* Categories Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {filteredCategories.map((category) => (
          <div
            key={category.id}
            className="border rounded-xl p-5 hover:shadow-lg transition"
          >
            <div className="flex justify-between items-start">
              <div>
                <FolderOpen
                  size={32}
                  className="text-blue-600 mb-3"
                />

                <h3 className="font-semibold text-lg">
                  {category.name}
                </h3>

                <p className="text-gray-500 text-sm mt-1">
                  {category.products} Products
                </p>
              </div>

              <div className="flex gap-2">
                <button className="bg-green-500 text-white p-2 rounded-lg">
                  <Edit size={16} />
                </button>

                <button
                  onClick={() =>
                    deleteCategory(category.id)
                  }
                  className="bg-red-500 text-white p-2 rounded-lg"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {filteredCategories.length === 0 && (
        <div className="text-center py-10 text-gray-500">
          No Categories Found
        </div>
      )}
    </div>
  );
}

export default Categories;